import * as R from 'ramda';
import classnames from 'classnames';
import intl from 'react-intl-universal';
import React, { useEffect, useRef, useState } from 'react';

import './VePlayer.scss';

interface VePlayerProps {
  url: string;
  poster: string;
  style?: React.CSSProperties;
  className?: string;
}

export const whenPlayerIsReady = () => {
  return new Promise<void>((resolve) => {
    const checkVePlayer = () => {
      // @ts-ignore
      if (window.VePlayer) {
        resolve();
      } else {
        if (!document.querySelector('link[href*="veplayer"]')) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href =
            '//lf-unpkg.volccdn.com/obj/vcloudfe/sdk/@volcengine/veplayer/1.9.5//index.min.css';
          document.head.appendChild(link);
        }
        if (!document.querySelector('script[src*="veplayer"]')) {
          const script = document.createElement('script');
          script.src =
            '//lf-unpkg.volccdn.com/obj/vcloudfe/sdk/@volcengine/veplayer/1.9.5//index.min.js';
          document.body.appendChild(script);
        }
        setTimeout(checkVePlayer, 100);
      }
    };
    checkVePlayer();
  });
};

export const VePlayer: React.FC<VePlayerProps> = ({
  url,
  poster,
  style = {},
  className,
}) => {
  const playerRef = useRef<any>(null);
  const playerIdRef = useRef(
    `veplayer-${Math.random().toString(36).substr(2, 9)}`
  );

  const loc = intl.getInitOptions().currentLocale;

  const lang = loc === 'zh-CN' ? 'zh' : 'en';

  const [isOverwhelmingWatching, setIsOverwhelmingWatching] =
    useState<boolean>(false);

  useEffect(() => {
    const initializePlayer = async () => {
      await whenPlayerIsReady();

      if (playerRef.current) {
        playerRef.current.destroy();
      }

      // 确保容器存在
      const mseContainer = document.getElementById(playerIdRef.current);
      if (mseContainer) {
        // @ts-ignore
        playerRef.current = new window.VePlayer({
          id: playerIdRef.current,
          url,
          width: '100vw',
          height: '100vh',
          autoplay: true,
          lang,
          poster,
          vodLogOpts: {
            vtype: 'MP4',
            line_app_id: playerIdRef.current,
          },
          marginControls: true,
        });
      }
    };

    initializePlayer().then();

    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
      }
    };
  }, [url, poster]);

  return (
    <div
      onClick={(e) => {
        if (R.pathEq('XG-TRIGGER', ['target', 'tagName'])(e)) {
          setIsOverwhelmingWatching(!isOverwhelmingWatching);
        }
      }}
      id={playerIdRef.current}
      className={classnames('veplayer-wrapper', {
        [className || '']: !!className,
      })}
      style={{
        ...style,
      }}
    >
      <style>
        {isOverwhelmingWatching
          ? `
            .veplayer-wrapper {
              > div {
                > *:not(:first-child) {
                  display: none;
                }
            
                > *:first-child {
                  > *:not(:first-child) {
                    display: none;
                  }
            
                  > .trigger {
                    display: block;
                  }
                }
              }
            }
            
            .veplayer-wrapper + div {
              display: none;
            }
            
            .vertical-swipper .close-button {
              display: none;
            }
        `
          : ''}
      </style>
    </div>
  );
};
